(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neills-offer-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neills-specials-browser')) {
  customElements.define('neills-specials-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.cards = Array.from(this.querySelectorAll('[data-offer-product]'));
      this.grid = this.querySelector('.nhs-offer-grid');
      this.search = this.querySelector('[data-search]');
      this.sort = this.querySelector('[data-sort]');
      this.buttons = Array.from(this.querySelectorAll('[data-room-filter]'));
      this.pagination = this.querySelector('[data-pagination]');
      this.pageSize = Number(this.dataset.pageSize) || 24;
      this.cards.forEach((card, index) => { if (!card.dataset.originalIndex) card.dataset.originalIndex = index; });
      this.buttons.forEach(button => {
        const count = this.cards.filter(card => button.dataset.roomFilter === 'all' || card.dataset.room === button.dataset.roomFilter).length;
        button.querySelector('[data-room-count]').textContent = `(${count})`;
        button.hidden = count === 0;
        button.addEventListener('click', () => { this.room = button.dataset.roomFilter; this.page = 1; this.update('replace'); }, options);
      });
      this.search.addEventListener('input', () => { this.page = 1; this.update('replace'); }, options);
      this.sort.addEventListener('change', () => { this.page = 1; this.update('replace'); }, options);
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.room = 'all'; this.search.value = ''; this.sort.value = 'featured'; this.page = 1; this.update('replace');
      }, options);
      this.pagination.addEventListener('click', event => {
        const link = event.target.closest('a[data-page]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.page = Number(link.dataset.page);
        this.update('push');
        this.pagination.querySelector('[aria-current="page"]')?.focus({ preventScroll: true });
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
      }, options);
      window.addEventListener('popstate', () => { this.readLocation(); this.update(); }, options);
      this.querySelector('[data-controls]').hidden = false;
      this.readLocation();
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.initialized = false;
    }
    readLocation() {
      const params = new URL(window.location.href).searchParams;
      const room = params.get('specials_room');
      this.room = this.buttons.some(button => button.dataset.roomFilter === room && !button.hidden) ? room : 'all';
      this.search.value = params.get('specials_q') || '';
      const sort = params.get('specials_sort') || 'featured';
      this.sort.value = Array.from(this.sort.options).some(option => option.value === sort) ? sort : 'featured';
      const page = Number(params.get('specials_page'));
      this.page = Number.isSafeInteger(page) && page > 0 ? page : 1;
    }
    pageUrl(page) {
      const url = new URL(window.location.href);
      const values = { specials_page: page > 1 ? page : '', specials_room: this.room !== 'all' ? this.room : '', specials_q: this.search.value.trim(), specials_sort: this.sort.value !== 'featured' ? this.sort.value : '' };
      Object.entries(values).forEach(([key, value]) => { if (value) url.searchParams.set(key, value); else url.searchParams.delete(key); });
      url.hash = 'neills-current-offers';
      return url;
    }
    renderPagination(totalPages) {
      this.pagination.replaceChildren();
      this.pagination.hidden = totalPages <= 1;
      if (totalPages <= 1) return;
      const addLink = (page, text, current = false) => {
        const link = document.createElement('a');
        link.href = this.pageUrl(page).href;
        link.dataset.page = page;
        link.textContent = text;
        link.setAttribute('aria-controls', this.grid.id);
        link.setAttribute('aria-label', this.pagination.dataset.position.replace('__page__', page).replace('__pages__', totalPages));
        if (current) link.setAttribute('aria-current', 'page');
        this.pagination.append(link);
        return link;
      };
      if (this.page > 1) { const previous = addLink(this.page - 1, this.pagination.dataset.previous); previous.rel = 'prev'; previous.setAttribute('aria-label', this.pagination.dataset.previous); }
      for (let page = 1; page <= totalPages; page++) addLink(page, String(page), page === this.page);
      if (this.page < totalPages) { const next = addLink(this.page + 1, this.pagination.dataset.next); next.rel = 'next'; next.setAttribute('aria-label', this.pagination.dataset.next); }
    }
    update(historyMode) {
      const term = this.search.value.trim().toLocaleLowerCase();
      const matches = this.cards.filter(card => (this.room === 'all' || card.dataset.room === this.room) && card.dataset.offerSearch.toLocaleLowerCase().includes(term));
      matches.sort((a, b) => {
        if (this.sort.value === 'price-low') return Number(a.dataset.offerPrice) - Number(b.dataset.offerPrice);
        if (this.sort.value === 'price-high') return Number(b.dataset.offerPrice) - Number(a.dataset.offerPrice);
        if (this.sort.value === 'name') return a.dataset.offerName.localeCompare(b.dataset.offerName);
        return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
      });
      const totalPages = Math.ceil(matches.length / this.pageSize);
      this.page = Math.min(Math.max(1, this.page), Math.max(1, totalPages));
      const visible = matches.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      this.cards.forEach(card => { card.hidden = true; });
      visible.forEach(card => { card.hidden = false; this.grid.append(card); });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.roomFilter === this.room)));
      const status = this.querySelector('[data-result-count]');
      status.textContent = status.dataset.countTemplate.replace('__shown__', visible.length).replace('__total__', matches.length);
      this.querySelector('[data-empty]').hidden = matches.length !== 0;
      this.renderPagination(totalPages);
      if (historyMode) window.history[historyMode === 'push' ? 'pushState' : 'replaceState']({}, '', this.pageUrl(this.page));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neills-pay-over-time"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('neills-payment-options')){
    class NeillsPaymentOptions extends HTMLElement{
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
        this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
        this.section=this.closest('.shopify-section');
        this.onVariant=event=>this.update(event.detail?.variant);
        this.section?.addEventListener('on:variant:change',this.onVariant);
        this.update(this.variants.find(variant=>String(variant.id)===this.dataset.variant));
      }
      disconnectedCallback(){this.section?.removeEventListener('on:variant:change',this.onVariant);this.initialized=false;}
      update(variant){
        const currency=this.dataset.currency||'USD';
        const whole=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency,maximumFractionDigits:0});
        const precise=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2});
        [12,36].forEach(term=>{
          const amount=term===12?variant?.price:variant?.compare_at_price;
          const valid=variant&&Number.isFinite(amount)&&amount>0&&(term===12||amount>=variant.price);
          const payment=this.querySelector('[data-payment="'+term+'"]');
          if(!payment)return;
          payment.textContent=valid?this.labels.monthly.replace('__AMOUNT__',whole.format(Math.ceil(amount/(term*100)))):variant?this.labels.missing:this.labels.choose;
          payment.classList.toggle('npo-unavailable',!valid);
          const basis=this.querySelector('[data-basis="'+term+'"]');
          basis.textContent=valid?(term===12?this.labels.sale:this.labels.regular)+' '+precise.format(amount/100):'';
          basis.hidden=!valid;
          this.querySelector('[data-below="'+term+'"]').hidden=!valid||amount>=(term===12?39999:99999);
        });
      }
    }
    customElements.define('neills-payment-options',NeillsPaymentOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neills-review-promo-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neills-review-card')) {
    class NeillsReviewCard extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.index = 0;
        this.timer = null;
        this.retry = null;
        this.inView = false;
        this.hovered = false;
        this.focused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.auto !== 'true' || this.motion.matches;
        this.content = this.querySelector('.nrc-content');
        this.controls = this.querySelector('.nrc-controls');
        this.toggle = this.querySelector('.nrc-toggle');
        this.promoItem = this.closest('li');
        if (this.promoItem) this.promoItem.hidden = true;
        const opts = { signal: this.abort.signal };
        this.querySelector('.nrc-prev').addEventListener('click', () => this.step(-1, true), opts);
        this.querySelector('.nrc-next').addEventListener('click', () => this.step(1, true), opts);
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, opts);
        this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, opts);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, opts);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, opts);
        this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); this.schedule(); }, opts);
        document.addEventListener('visibilitychange', () => this.schedule(), opts);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.updateToggle(); this.schedule(); }, opts);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.loadReviews(0);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.retry);
        this.abort?.abort();
        this.observer?.disconnect();
      }
      safeGoogleUrl(value) {
        try {
          const url = new URL(value);
          if (url.protocol === 'https:' && (url.hostname === 'google.com' || url.hostname.endsWith('.google.com'))) return url.href;
        } catch {}
        return '';
      }
      loadReviews(attempt) {
        const feed = window._appioGoogleReviewsData;
        if (!Array.isArray(feed?.reviews)) {
          if (attempt < 20) this.retry = setTimeout(() => this.loadReviews(attempt + 1), 500);
          return;
        }
        const seen = new Set();
        this.reviews = feed.reviews.filter(review => {
          const key = review.reviewId || review.id;
          if (Number(review.rating) !== 5 || typeof review.originalText !== 'string' || !review.originalText.trim() || !review.authorName || !this.safeGoogleUrl(review.reviewUrl) || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        if (!this.reviews.length) return;
        this.index = Math.floor(Math.random() * this.reviews.length);
        this.renderReview();
        this.controls.hidden = this.reviews.length < 2;
        this.updateToggle();
        if (this.promoItem) this.promoItem.hidden = false;
        this.schedule();
      }
      updateToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      }
      step(direction, manual = false) {
        if (!this.reviews?.length) return;
        if (manual) { this.paused = true; this.updateToggle(); }
        this.index = (this.index + direction + this.reviews.length) % this.reviews.length;
        this.content.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.renderReview();
        this.schedule();
      }
      renderReview() {
        const review = this.reviews[this.index];
        const text = review.originalText.trim();
        const excerpt = text.length > 130;
        let quote = text;
        if (excerpt) {
          quote = text.slice(0, 130);
          const space = quote.lastIndexOf(' ');
          if (space > 80) quote = quote.slice(0, space);
          quote = quote.trimEnd() + '…';
        }
        this.querySelector('.nrc-kind').textContent = excerpt ? this.dataset.excerptLabel : this.dataset.fullLabel;
        this.querySelector('.nrc-quote').textContent = '“' + quote + '”';
        this.querySelector('.nrc-author').textContent = review.authorName;
        const dateElement = this.querySelector('.nrc-date');
        const dateValue = String(review.createdAt || '').slice(0, 10);
        const date = /^\d{4}-\d{2}-\d{2}$/.test(dateValue) ? new Date(dateValue + 'T12:00:00Z') : null;
        if (date && !Number.isNaN(date.getTime())) {
          dateElement.dateTime = dateValue;
          dateElement.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month:'short', day:'numeric', year:'numeric', timeZone:'UTC' }).format(date);
        } else { dateElement.removeAttribute('datetime'); dateElement.textContent = ''; }
        const link = this.querySelector('.nrc-original');
        link.href = this.safeGoogleUrl(review.reviewUrl);
        link.hidden = false;
        this.dataset.reviewId = String(review.reviewId || review.id);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.inView || this.paused || this.hovered || this.focused || document.hidden || (this.reviews?.length || 0) < 2) return;
        const interval = Math.max(6000, Number(this.dataset.interval) || 10000);
        this.timer = setTimeout(() => this.step(1), interval);
      }
    }
    customElements.define('neills-review-card', NeillsReviewCard);
  }
  } catch(e) { console.error(e); }
})();

})();
